import React from 'react';

const SideNavButton = props => {
  const { drawVisible, showDraw, hideDraw } = props;
  return !drawVisible ? (
    <div className="col-auto header__col" onClick={showDraw}>
      <div className="header__burger">
        <div className="header__burger-line"></div>
        <div className="header__burger-line"></div>
        <div className="header__burger-line"></div>
      </div>
    </div>
  ) : (
    <div className="col-auto header__col opended" onClick={hideDraw}>
      <div className="header__burger" id="js-burger">
        <div className="header__burger-line"></div>
        <div className="header__burger-line"></div>
        <div className="header__burger-line"></div>
      </div>
    </div>
  );
};

export default SideNavButton;
